<template>
  <section class="ch-list" aria-label="Call records">
    <div class="ch-list__head">
      <div class="ch-list__columns" aria-hidden="true">
        <span>Start time</span>
        <span>From number</span>
        <span>Caller name</span>
        <span>Direction</span>
        <span>Status</span>
        <span>Duration</span>
        <span>Details</span>
      </div>
    </div>

    <div class="ch-list__scroll">
      <div v-if="loading" class="ch-list__body">
        <div v-for="n in 8" :key="n" class="ch-row ch-row--skeleton" />
      </div>

      <div v-else-if="calls.length" class="ch-list__body" role="list">
        <CallHistoryRow
          v-for="call in calls"
          :key="call.id"
          :call="call"
          @open-detail="$emit('open-detail', $event)"
        />
      </div>

      <div v-else-if="isSearchActive" class="ch-empty">
        <v-icon icon="mdi-magnify-close" size="40" class="ch-empty__icon" />

        <p class="ch-empty__title">No matching calls</p>

        <p class="ch-empty__subtitle">
          Try another search or clear the app bar filter.
        </p>
      </div>

      <div v-else class="ch-empty">
        <v-icon icon="mdi-phone-off-outline" size="40" class="ch-empty__icon" />

        <p class="ch-empty__title">No call history yet</p>

        <p class="ch-empty__subtitle">
          Calls handled by your AI call agent will appear here.
        </p>
      </div>
    </div>
  </section>
</template>

<script setup>
import CallHistoryRow from "@/components/CallHistory/CallHistoryRow.vue";

defineOptions({ name: "CallHistoryList" });

defineProps({
  calls: { type: Array, default: () => [] },

  loading: { type: Boolean, default: false },

  isSearchActive: { type: Boolean, default: false },
});

defineEmits(["open-detail"]);
</script>
